import * as stylex from "@stylexjs/stylex";
import { ArrowRight, Bell } from "lucide-react";
import type { MouseEvent } from "react";
import type { TagColor } from "@/domain/schemas";
import "@/theme/tokens.stylex";
import { colors, radii, shadows } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import { Button } from "./Button";
import { Icon } from "./Icon";
import { PersonDot } from "./PersonDot";
type ReminderStripProps = {
  color: TagColor | "soft";
  eyebrow: string;
  title: string;
  label: string;
  actionLabel: string;
  left?: number;
  onOpen: () => void;
  xstyle?: stylex.StyleXStyles;
};
const _temp = {
  k3aq6I: "xsqj5wx",
  "$$css": true
};
const styles = {
  root: {
    kB7OPa: "x9f619",
    kzqmXN: "xh8yej3",
    ks0D6T: "xyzno7u",
    kVQacm: "xb3r6kr",
    kaIpWk: "xwe7p7i",
    kWkggS: "x1i4uan3",
    kMwMTN: "x1btspmr",
    kGVxlE: "xs0yqle",
    kkrTdU: "x1ypdohk",
    $$css: true
  },
  fill: {
    kZKoxP: "x5yr21d",
    kWkggS: "x1f7iotj",
    k3nNDw: "x19w6rv",
    k1ekBW: "x11xpdln",
    kIyJzY: "x16fj20d x12w9bfk",
    kAMwcw: "xcj1dhv",
    $$css: true
  },
  left: (left: number) => [_temp, {
    "--x-transform": `scaleX(${left})` != null ? `scaleX(${left})` : undefined
  }]
};
export function ReminderStrip({
  color,
  eyebrow,
  title,
  label,
  actionLabel,
  left = 1,
  onOpen,
  xstyle
}: ReminderStripProps) {
  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: the strip stays out of the focus order (NOTIF-05); the tap is a pointer shortcut for Details
    <div role="status" aria-label={label} onClick={onOpen} onMouseDown={keepFocus} {...stylex.props(styles.root, xstyle)}>
      <div className="x78zum5 x6s0dn4 x1c1vhfx x1xn8qrt xtuk6xr">
        <Icon icon={Bell} size={28} />
        <div className="x98rzlu xeuugli x78zum5 xdt5ytf x1jnr06f">
          <span className="x78zum5 x6s0dn4 x883omv xr0iwhn x1j61zf2 x1u7k74 xbac8wx xtvhhri">
            <PersonDot color={color} />
            <span className="xeuugli xuxw1ft xb3r6kr xlyipyv">{eyebrow}</span>
          </span>
          <span className="xneq65o xfbjfs5 x1uo3zyz xrg9stw xeuugli xuxw1ft xb3r6kr xlyipyv">{title}</span>
        </div>
        <Button variant="inverse" iconRight={ArrowRight} tabIndex={-1}>
          {actionLabel}
        </Button>
      </div>
      <div className="xqu0tyb x2d2rt8">
        <div {...stylex.props(styles.fill, styles.left(left))} />
      </div>
    </div>
  );
}
function keepFocus(event: MouseEvent) {
  event.preventDefault();
}